import { createFileRoute, redirect } from "@tanstack/react-router";
import { BlogPage } from "@/content-site/components/blog-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
import { findBlogRedirect } from "@/content-site/lib/blog";
export const Route = createFileRoute("/_content/blog/$slug/")({
  loader: ({ params }) => {
    const destination = findBlogRedirect(params.slug);
    if (destination) throw redirect({ to: destination, statusCode: 301, search: true });
    return loadContentPage(["blog", params.slug]);
  },
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <BlogPage data={Route.useLoaderData()} />;
}
